import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, selectAll, selectEntities } from '../reducers/languages.reducer';

export const getLanguagesState = createFeatureSelector<State>('languagesState');

export const selectLanguageEntities = createSelector(getLanguagesState, state => selectEntities(state));
export const selectLanguages = createSelector(getLanguagesState, state => selectAll(state));
export const getLoading = createSelector(getLanguagesState, state => state.loading);
export const getLastLoaded = createSelector(getLanguagesState, state => state.lastLoaded);
